/* Salary Advances API client — Phase 5 Bundle A
 *
 * UI shape: month-keyed object:
 *   salaryAdvances["April 2026"] = [{ id, employeeName, date, amount, note }, ...]
 *
 * API shape: flat with billingMonth + employeeId
 */
import { api } from "./api";
import { monthLabelToYM } from "./attendanceApi";

const BASE = "/salary-advances";

export function advanceApiToUi(r) {
  return {
    id: r.id,
    employeeId: r.employeeId,
    employeeName: r.employeeName || "",
    date: r.date ? String(r.date).slice(0, 10) : "",
    amount: r.amount != null ? Number(r.amount) : 0,
    note: r.note || "",
  };
}

export const salaryAdvancesApi = {
  async listByMonth(monthLabel) {
    const month = monthLabelToYM(monthLabel);
    if (!month) return [];
    const rows = await api.get(`${BASE}?billingMonth=${encodeURIComponent(month)}`);
    return (Array.isArray(rows) ? rows : []).map(advanceApiToUi);
  },

  async create({ employeeId, date, amount, note, billingMonth }) {
    // billingMonth comes in as month label "April 2026"; convert to "2026-04"
    const ym = monthLabelToYM(billingMonth);
    const res = await api.post(BASE, { employeeId, date, amount, note, billingMonth: ym });
    return advanceApiToUi(res);
  },

  async update(id, patch) {
    const payload = {};
    if (patch.date)   payload.date = patch.date;
    if (patch.amount !== undefined) payload.amount = patch.amount;
    if (patch.note !== undefined)   payload.note = patch.note;
    const res = await api.patch(`${BASE}/${encodeURIComponent(id)}`, payload);
    return advanceApiToUi(res);
  },

  async delete(id) {
    return api.delete(`${BASE}/${encodeURIComponent(id)}`);
  },
};
